import type { MarketplaceProfileTurnaround } from '@foodfluence/shared';
import type { LocalCreatorsPackageRow, LocalCreatorsProfileImage, TopContentSlotEntry } from '../types';

export type MarketplaceFormSnapshot = {
  bio: string;
  slug: string;
  turnaround: MarketplaceProfileTurnaround | null;
  marketplaceBrands: string[];
  packages: LocalCreatorsPackageRow[];
  topSlots: (TopContentSlotEntry | null)[];
  isAccountActive: boolean;
  /** `null` = use main account profile photo (no marketplace override). */
  profileImage: LocalCreatorsProfileImage | null;
};

export type ProfileLoadPhase = 'idle' | 'loading' | 'new' | 'bootstrapping' | 'ready';

/** Only keys present on the patch are sent to the API (merge semantics). */
export type MarketplaceProfilePatch = {
  bio?: string;
  slug?: string;
  turnaround?: MarketplaceProfileTurnaround | null;
  marketplaceBrands?: string[];
  packages?: LocalCreatorsPackageRow[];
  topSlots?: (TopContentSlotEntry | null)[];
  profileImage?: LocalCreatorsProfileImage | null;
  isAccountActive?: boolean;
  deactivationReason?: string;
};

export type UpsertProfileOptions = {
  /** Suppress slug validation toast (bootstrap). */
  quietSlugValidation?: boolean;
};

/** Fields synced by debounced auto-save — excludes slug and account status. */
export const MARKETPLACE_AUTO_SAVE_PATCH_KEYS = [
  'bio',
  'turnaround',
  'marketplaceBrands',
  'packages',
  'topSlots',
  'profileImage',
] as const satisfies readonly (keyof MarketplaceProfilePatch)[];

export function pickAutoSavePatch(snapshot: MarketplaceFormSnapshot): MarketplaceProfilePatch {
  return {
    bio: snapshot.bio,
    turnaround: snapshot.turnaround,
    marketplaceBrands: snapshot.marketplaceBrands,
    packages: snapshot.packages,
    topSlots: snapshot.topSlots,
    profileImage: snapshot.profileImage,
  };
}
